<template>
  <div class="page">
    <h2 class="title">第三方信息共享清单</h2>
    <p class="strong">
      一、与第三方共享个人信息（非SDK）
    </p>
    <p>
      在有看投向您提供产品或服务时，有看投可能会与其他第三方共享您的个人信息，以保证产品或服务的顺利完成。有看投可能会对外共享的个人信息接收方具体如下表。
    </p>
    <table>
      <thead>
        <tr>
          <th>接收方名称</th>
          <th>共享个人信息种类</th>
          <th>目的</th>
          <th>共享方式</th>
          <th>联系方式</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>阿里云计算有限公司</td>
          <td>手机号码</td>
          <td>
            用于您接收服务短信
          </td>
          <td>加密接口传输</td>
          <td>4006021010</td>
        </tr>
      </tbody>
    </table>
    <p class="strong">
      二、第三方SDK信息
    </p>
    <p>
      有看投的部分服务需要由有看投与第三方（有看投客户端嵌入的第三方SDK）共同为您提供。以下为有看投接入的第三方SDK的具体信息。为了持续优化有看投的服务，有看投可能会调整接入的第三方SDK并更新下述SDK清单。
    </p>
    <table>
      <thead>
        <tr>
          <th>序号</th>
          <th>第三方SDK</th>
          <th>使用目的、收集信息/调用权限类型、第三方隐私政策/官网链接</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td>腾讯移动推送 TPNS SDK</td>
          <td>
            为了帮助您使用“消息通知”功能，为您提供消息推送服务，我们可能会调用腾讯移动推送
            TPNS
            SDK，可能会收集/调用设备信息(手机型号，系统类型、系统版本)用于标签化推送以及识别是否是真机、网络信息(网络类型)支持根据不同网络类型进行不同类型推送、应用数据（推送流程中产生的送达、点击、曝光等数据）用于推送业务数据统计，终端IP用于网络链路优化，具体详见该第三方的隐私政策 https://privacy.qq.com/document/preview/8565a4a2d26e480187ed86b0cc81d727；
          </td>
        </tr>
        <tr>
          <td>2</td>
          <td>小米推送 SDK</td>
          <td>
            对小米品牌手机消息推送，可能会收集/调用
            1、Android版本：设备标识(OAID和加密的Android
            ID)，以及使用推送服务的应用信息如应用包名、版本号和运行状态；
            iOS版：IDFV（当收集不到IDFV时则不收集）、应用包名、版本号；
            2、Android版本：消息创建、送达和点击时间并暂存从第三方应用处获得并推送给您的消息内容；
            iOS版本：消息创建、送达时间，并暂存从第三方应用处获得并推送给您的消息内容。
            3、Android版本：设备相关信息如设备厂商、设备型号、设备内存、操作系统版本、小米推送SDK版本、设备归属地（国家或地区）、SIM卡运营商名称、当前网络类型、SSID。其中当前网络类型、SIM卡运营商名称仅在设备本地读取，不会上传至小米服务器；
            iOS版本：设备相关信息如设备型号、操作系统版本、小米推送SDK版本；
            4、Android版本：通知栏设置信息，包括是否屏蔽通知栏、是否设置锁屏弹出消息等。
            具体详见该第三方的隐私政策 https://dev.mi.com/console/doc/detail?pId=1822；
          </td>
        </tr>
        <tr>
          <td>3</td>
          <td>华为推送 SDK</td>
          <td>
            对华为品牌手机消息推送，可能会收集/调用应用基本信息（AppID，应用版本号和应用包名，华为推送SDK版本号，已安装应用列表用于获取推送服务应用和HMS
            Core应用版本号）、应用内设备标识符（AAID，Push
            Token）、设备标识符（Android
            ID）、设备的硬件信息（设备类型，设备型号）、系统基本信息（系统类型，系统版本）、系统设置信息（国家码）、网络信息（BSSID），具体详见该第三方的隐私政策 https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177；
          </td>
        </tr>
        <tr>
          <td>4</td>
          <td>OPPO PUSH SDK</td>
          <td>
            对OPPO品牌手机消息推送，可能会收集/调用消息内容、设备相关信息（如IMEI或OAID，Serial
            Number，IMSI，User ID，Android ID，Google Advertising ID,
            手机Region设置，设备型号，手机电量、手机操作系统版本及语言）、使用推送服务的应用信息（如APP包名及版本号，运行状态）、推送SDK版本号、网络相关信息（如IP或域名连接结果，当前网络类型）、消息发送结果、通知栏状态（如通知栏权限、用户点击行为）、锁屏状态（如是否锁屏，是否允许锁屏通知）、广告主或开发者的指示收集终端用户的设备识别码（IMEI或OAID）、IP地址、客户端系统、客户端网络类型、客户端时间（部分场景），具体详见该第三方的隐私政策 https://open.oppomobile.com/wiki/doc#id=10288；
          </td>
        </tr>
        <tr>
          <td>5</td>
          <td>vivo PUSH SDK</td>
          <td>
            对vivo品牌手机消息推送，可能会收集/调用设备标识信息（如IMEI、EmmCID、UFSID、ANDROIDID、GUID、GAID、OPENID、VAID、OAID、RegID、加密的Android
            ID）、使用推送服务的应用软件信息（如应用包名、版本号、APPID、安装、卸载、恢复出厂设置、运行状态）、设备制造商、网络类型、国家码、设备类型、消息创建/送达和点击的时间戳、消息内容、推送SDK版本号、设备型号、操作系统版本、当前网络类型、消息发送结果、通知栏状态（如通知栏权限、用户点击行为）、锁屏状态（如是否锁屏，是否允许锁屏通知），具体详见该第三方的隐私政策 https://dev.vivo.com.cn/documentCenter/doc/652#w1-08512613；
          </td>
        </tr>
        <tr>
          <td>6</td>
          <td>魅族推送 SDK</td>
          <td>
            对魅族品牌手机消息推送，可能会收集/调用设备信息（手机型号、IMEI
            号、UUID、MEID）、应用信息、日志信息、其他信息、位置信息、推送SDK版本号、网络相关信息、消息发送结果、通知栏状态、锁屏状态，具体详见该第三方的隐私政策
            http://static.meizu.com/resources/term/privacy8.html；
          </td>
        </tr>
        <tr>
          <td>7</td>
          <td>APNs SDK</td>
          <td>
            对苹果品牌手机消息推送，可能会调用通知权限，具体详见该第三方的隐私政策 https://www.apple.com/legal/privacy/en-ww/；
          </td>
        </tr>
        <tr>
          <td>8</td>
          <td>友盟移动统计SDK</td>
          <td>
            为了进行APP数据统计分析，我们可能会调用友盟移动统计SDK，收集您的设备信息（Android
            ID/IDFA/IDFV/OAID/OpenUDID/GUID；
            /IMEI/IMSI）、网络信息、位置信息、应用列表，具体详见该第三方的隐私政策 https://www.umeng.com/page/policy；
          </td>
        </tr>
        <tr>
          <td>9</td>
          <td>腾讯浏览服务X5网页引擎SDK（Android）</td>
          <td>
            为了能够更好的为您提供展示及播放服务，我们可能会调用腾讯浏览服务X5网页引擎SDK（Android），收集您的设备信息（设备型号、操作系统、AndroidID、CPU类型）、应用信息（宿主应用包名，版本号）、Wi-Fi状态和参数（不包含wifi
            mac）。具体详见该第三方的隐私政策 https://rule.tencent.com/rule/1c4e2b4b-d0f6-4a75-a5c6-1cfce00a390d；
          </td>
        </tr>
        <tr>
          <td>10</td>
          <td>号码认证SDK</td>
          <td>
            为了方便您登录，我们可能会调用 号码认证
            SDK，可能收集您的网络类型、切换wifi和蜂窝网络通道、设备信息（含IP地址、设备制造商、设备型号、手机操作系统、SIM卡信息SIM
            State）。具体详见该第三方的隐私政策https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112211045_86198.html；
            号码认证SDK服务集成三大运营商用户本机号码认证及一键登录及技术服务SDK，三大运营商如何处理用户个人信息，详见如下及隐私政策。
            中国移动 运营主体:中国移动通信集团有限公司
            功能:识别用户的手机号码快速登录，以及查询、分析和风险控制。
            收集个人信息类型:网络类型、网络地址、运营商类型、本机号码信息、SIM卡状态、手机设备类型、手机操作系统、硬件厂商。
            隐私权政策链接https://wap.cmpassport.com/resources/html/contract2.html
            中国联通 运营主体:中国联合网络通信集团有限公司
            功能:识别用户的手机号码快速登录，以及实现业务风控
            收集个人信息类型:网络类型、网络地址、运营商类型、本机手机号、手机设备类型、手机操作系统、硬件厂商。
            隐私政策链接https://opencloud.wostore.cn/authz/resource/html/disclaimer.html?spm=a2c4g.11186623.0.0.41f1633eHxMLkQ&fromsdk=true
            中国电信 运营主体:中国电信集团有限公司
            功能:识别用户的手机号码快速登录，以及实现业务风控
            收集个人信息类型:网络IP地址、网络类型、注册手机号码、本机号码、国际移动用户标识码、应用进程信息、网络连接类型、网络状态信息、网络地址、运营商类型、手机设备类型、手机设备厂商、手机操作系统类型及版本。
            隐私政策链接 https://e.189.cn/sdk/agreement/detail.do?spm=a2c4g.11186623.0.0.41f1633eHxMLkQ&appKey=E_189&hidetop=true&returnUrl=
          </td>
        </tr>
        <tr>
          <td>11</td>
          <td>阿里云播放器SDK</td>
          <td>
            当您观看视频时，我们会调用阿里云播放器SDK
            ，可能收集您的网络类型、设备信息（包括设备型号、操作系统、唯一设备标识符、阿里云播放器软件版本号）、日志信息。
            具体详见该第三方的隐私政策 https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112151438_20307.html；
          </td>
        </tr>
        <tr>
          <td>12</td>
          <td>微信分享</td>
          <td>
            为实现让您使用“微信分享”功能，可能需要网络权限，涉及的个人信息包含头像、昵称、地区、性别、网络信息与包含ICCID、IMSI、IMEI、MAC地址、Android_id在内的设备信息。具体详见该第三方的隐私政策https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&t=weixin_agreement&s=privacy；
          </td>
        </tr>
        <tr>
          <td>13</td>
          <td>支付宝SDK</td>
          <td>
            为了帮助您使用“支付宝支付”功能完成付款，需要收集您的设备信息（设备标识IMSI/IMEI/MEID/OAID/SIM卡序列号ICCID/Android
            ID/MAC地址、BSSID/SSID、MCC/MNC、Wifi列表、设备序列号、设备账户信息）、位置信息、应用列表、外部储存、传感器信息。具体详见该第三方的隐私政策 https://render.alipay.com/p/yuyan/180020010001196791/preview.html?agreementId=AG00000132；
          </td>
        </tr>
        <tr>
          <td>14</td>
          <td>微信支付</td>
          <td>
            为了帮助您使用“微信支付”功能完成付款，需要调取您的个人身份信息、设备信息（硬件设备型号、终端系统类型、设备识别码）、网络连接信息（包含IMSI信息、移动网络信息）、IP地址、使用的软件版本信息、软件语言设置信息、地理位置信息、标准网络日志数据、网络使用习惯以及您使用微信支付服务的操作记录。具体详见该第三方的隐私政策 https://www.tenpay.com/v3/helpcenter/low/privacy.shtml。
          </td>
        </tr>
        <tr>
          <td>15</td>
          <td>Bugly SDK</td>
          <td>
            为了崩溃分析、问题检测和用户行为数据统计，需要收集您的Android
            ID、PID、网络类型、应用当前正在运行的进程名。具体详见该第三方的隐私政策
            https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56
          </td>
        </tr>
        <tr>
          <td>16</td>
          <td>抖音支付OpenSDK</td>
          <td>
            为了帮助您在APP内选择抖音支付付款时快速唤起抖音(含极速版、火山版)APP，并调用抖音APP内的支付模块，需要收集您的设备IP信息、设备标识符(Android如AndroidlD、OAID)。具体详见该第三方的隐私政策
            https://lf3-cdn-tos.draftstatic.com/obj/ies-hotsoon-draft/douyinpay/a7c59a38-cc7e-4c91-9051-c5d5058f24f9.html
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<style>
html,
body {
  background-color: #ffffff;
  word-break: break-all;
}
table {
  margin: 20px 0;
  min-height: 25px;
  line-height: 45px;
  text-align: center;
  border-collapse: collapse;
}
table,
table tr th,
table tr td {
  border: 1px solid #000000;
}
td {
  padding: 0 10px;
}

* {
  padding: 0;
  margin: 0;
}

.black body,
body.black {
  background-color: #111112;
  color: #bfbfbf;
}

a {
  color: #4690ef;
}

.page {
  padding: 15px 10px 30px;
  max-width: 750px;
  margin: 0 auto;
  font-size: 30px;
}

.title {
  text-align: center;
}

h2 {
  font-weight: bold;
  font-size: 32px;
  margin: 15px 0;
}

.strong {
  font-weight: bold;
}

p {
  text-indent: 2em;
}

.btn-cancel {
  margin: 45px 22px 0;
  border: 1px solid #dddddd;
  border-radius: 5px;
  line-height: 100px;
  text-align: center;
  font-size: 17px;
  color: #8c8c8c;
  display: none;
}

.black .btn-cancel {
  border-color: #1e262a;
  color: #828282;
}
</style>
<script>
import { Log } from '@em/ym'

export default {
  mounted() {
    Log.pageView({
      pageId: 'Html:PrivacySdklist'
    })
  }
}
</script>
